<template>
  <form class="pay px-dynamic" @submit.prevent="">
    <div class="row">
      <div class="d-flex align-items-center">
        <label for="sdate"><span>С</span></label>
        <!-- <input
          type="month"
          v-model="sdate"
          name="sdate"
          class="input-text"
          :min="this.mindate"
          :max="this.maxdate"
          requireds
        /> -->
        <month-picker-input
          style="z-index: 1"
          lang="ru"
          :editable-year="false"
          :min-date="this.mindate"
          :max-date="this.maxdate"
          :default-year="maxdate.getFullYear() - 1"
          :default-month="maxdate.getMonth() + 1"
          @change="(value) => (sdate = value.from)"
        />
      </div>
      <div class="d-flex align-items-center">
        <label for="edate"><span>по</span></label>
        <!-- <input
          type="month"
          v-model="edate"
          name="edate"
          class="input-text"
          :min="this.mindate"
          :max="this.maxdate"
          required
        /> -->
        <month-picker-input
          style="z-index: 1"
          lang="ru"
          :editable-year="false"
          :min-date="this.mindate"
          :max-date="this.maxdate"
          :default-year="maxdate.getFullYear()"
          :default-month="maxdate.getMonth() + 1"
          @change="(value) => (edate = value.from)"
        />
      </div>
      <div class="d-flex align-items-center ml-3">
        по лицевому счету <!--{{ clnums[0] }} - -->
        {{ client.clientGroup[0].clientName }}
        <!-- <div class="d-flex align-items-center">
        <label for="clnum"><span>по лицевому счету</span></label>
        <select
          v-model="currentClnum"
          class="input-text clnum-input"
          v-if="clnums.length > 0"
        >
          <option v-for="(clnum, index) in clnums" :key="clnum" :value="clnum">
            {{ clnum }} - {{ client.clientGroup[index].clientName }}
          </option>
        </select>
      </div> -->
      </div>
    </div>

    <div class="d-flex col-10 justify-content-between row">
      <div class="col-3 my-4" v-if="canDownload">
        <button @click="download" class="btn btn-blue">Акт сверки</button>
      </div>
      <!-- <div class="col-3 my-4 ml-4">
        <button @click="show" class="btn btn-blue">Показать</button>
      </div> -->
      <!-- <month-picker-input style="z-index: 1;" lang="ru" @input="value => test = value.from" /> -->
    </div>
    <div class="col-12 col-md-6 row"></div>
    <div v-if="error" class="col-12">
      <div style="color: red">{{ error }}</div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { MonthPickerInput } from "vue-month-picker";

export default {
  data() {
    return {
      sdate: new Date(),
      edate: new Date(),
      maxdate: new Date(),
      mindate: new Date(),
      currentClnum: -1,
      clnums: [],
      init: false,
      updateTimer: null,
    };
  },
  props: ["error", "canDownload"],
  components: {
    MonthPickerInput,
  },

  computed: {
    ...mapGetters(["client"]),
    ...mapState(["groupDiscounts"]),
  },

  created() {
    this.clnums = this.client.clientGroup.map((el) => el.clientId);
    this.currentClnum = this.historyCurrentClnum ?? this.clnums[0];
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    now.setDate(1);
    now.setHours(3, 0, 0, 0);
    this.maxdate = new Date(now);
    //this.maxdate.setMonth(this.maxdate.getMonth() - 1);
    this.edate = new Date(now);
    this.mindate = new Date(now);
    this.setMinDateContract();
    if (
      this.mindate === "" ||
      this.mindate === null ||
      this.mindate === undefined
    ) {
      this.mindate = new Date(now);
    }
    this.sdate = new Date(now);
    this.sdate.setFullYear(now.getFullYear() - 1);
    if (!this.groupDiscounts) {
      this.show();
    }
  },
  watch: {
    currentClnum() {
      this.setMinDateContract();
      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.updateTimer = setTimeout(() => {
        if (this.init) {
          this.show();
        } else {
          this.init = true;
        }
      }, 500);
    },

    sdate() {
      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.sdate.setDate(1);
      this.sdate.setHours(3, 0, 0, 0);

      this.updateTimer = setTimeout(() => {
        if (this.init) {
          this.show();
        } else {
          this.init = true;
        }
      }, 500);
    },
    edate() {
      if (this.updateTimer) clearTimeout(this.updateTimer);
      this.edate.setDate(1);
      this.edate.setHours(3, 0, 0, 0);
      this.updateTimer = setTimeout(() => {
        if (this.init) {
          this.show();
        } else {
          this.init = true;
        }
      }, 500);
    },
  },

  methods: {
    ...mapMutations(["setGroupDiscounts", "setHistoryCurrentClnum"]),
    setMinDateContract() {
      const index = this.clnums.indexOf(this.currentClnum);
      if (index > -1) {
        const sortedContracts = this.client.clientGroup[
          index
        ].contracts.toSorted(
          (prev, next) => new Date(prev.date) - new Date(next.date),
        );
        if (sortedContracts.length > 0) {
          let i = 0;
          let resContract = sortedContracts[i];
          while (
            new Date(resContract.date) < new Date() &&
            i < sortedContracts.length
          ) {
            resContract = sortedContracts[i++];
          }
          this.mindate = new Date(resContract.date);
          const ignoreContracts = true;
          if (
            ignoreContracts ||
            (this.mindate !== "" &&
              Math.abs(
                new Date().getFullYear() - new Date(this.mindate).getFullYear(),
              ) > 5)
          ) {
            const curDate = new Date();
            let date = new Date(curDate.getFullYear() - 1, 0, 1);
            date.setFullYear(date.getFullYear() - 3);
            this.mindate = new Date(date);
          }
          if (new Date(this.mindate) > new Date(this.sdate)) {
            this.sdate = new Date(this.mindate);
          }
        }
      }
    },

    validate(stime, etime) {
      let error = null;
      const index = this.clnums.indexOf(this.currentClnum);
      if (index < 0 || !this.currentClnum) {
        error = "Проверьте правильность ввода введенного номера лицевого счета";
      }
      if (
        !this.edate ||
        !this.sdate ||
        stime < new Date(this.mindate) ||
        stime > Date.now() ||
        stime > etime
      ) {
        error = "Проверьте правильность ввода временного периода";
      }
      return error;
    },

    download() {
      const now = new Date();
      const starttime = new Date(this.sdate);
      const endtime = new Date(this.edate);
      if (endtime >= now) {
        endtime.setMonth(now.getMonth());
      } else {
        endtime.setMonth(endtime.getMonth() + 1);
      }
      this.$emit(
        "download",
        this.validate(starttime, endtime),
        starttime,
        endtime,
        this.currentClnum,
      );
    },

    show() {
      const now = new Date();
      const starttime = new Date(this.sdate);
      const endtime = new Date(this.edate);
      if (endtime >= now) {
        endtime.setMonth(now.getMonth());
      } else {
        endtime.setMonth(endtime.getMonth() + 1);
      }
      this.$emit(
        "show",
        this.validate(starttime, endtime),
        starttime,
        endtime,
        this.currentClnum,
        this.client.clientGroup.find((el) => el.clientId === this.currentClnum)
          .clientName,
      );
    },
  },
};
</script>

<style></style>
